import { css } from "@emotion/react";
import { useHistory } from "react-router";

import { ActionModal } from "@livechat/design-system";
import { Button } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon";
import Flex from "components/layout/Flex";

type Props = {
  onClose: () => void;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const SubscriptionPaymentIssueModal = ({ onClose }: Props) => {
  const history = useHistory();

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleUpdateBilling = () => {
    onClose();
    history.push("/subscription/account-details");
  };

  return (
    <ActionModal
      icon={<Icon name={IconsEnum.ErrorInfo} height="54px" width="54px" />}
      css={css({ width: "600px" })}
      onClose={onClose}
      heading="Payment needed to keep your account active"
      actions={
        <Flex gap="8px">
          <Button kind="secondary" onClick={onClose} size="large">
            Cancel
          </Button>
          <Button kind="primary" onClick={handleUpdateBilling} size="large">
            Update billing details
          </Button>
        </Flex>
      }
    >
      There was an issue processing your subscription payment. To continue using HelpDesk without restrictions, please
      update your payment details.
    </ActionModal>
  );
};
